/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import { LayoutServicePageState } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import Script from 'next/script';

const OneTrust = (): JSX.Element => {
  const {
    sitecoreContext: { pageState, oneTrustScriptID },
  } = useSitecoreContext();
  return (
    <>
      {pageState === LayoutServicePageState.Normal && oneTrustScriptID && (
        <>
          <Script
            src={`https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js`}
            strategy="beforeInteractive"
            data-document-language="true"
            data-domain-script={oneTrustScriptID}
          />
        </>
      )}
    </>
  );
};

export default OneTrust;
